import { UPDATE_FLAVOR } from "../actions-index";

export function flavor(state = "", action) {
    switch (action.type) {
        case UPDATE_FLAVOR:
            return action.payload;
        default:
            return state
    }
}